import { Expense } from "../Expense/Expense.type";
import { Payment } from "../Payment/Payment.type";
import { ApiCallState } from "../Utils";

export type Attendance = {
  id: number;
  name: string;
  description: string;
  unique_uuid: string;
  type: string;
  user_id: number;
  date: string;
  in_time: string;
  out_time: string;
  in_format: string;
  out_format: string;
  scope: string;
};

export type AttendanceStateTypes = {
  fetchAll: ApiCallState<Attendance[]>;
};

export const AttendanceActionTypes = {
  FETCH_ALL_ATTENDANCE: "FETCH_ALL_ATTENDANCE",
  FETCH_ALL_ATTENDANCE_RESET: "FETCH_ALL_ATTENDANCE_RESET",
  FETCH_ALL_ATTENDANCE_FAILURE: "FETCH_ALL_ATTENDANCE_FAILURE",
  FETCH_ALL_ATTENDANCE_SUCCESS: "FETCH_ALL_ATTENDANCE_SUCCESS",
};
